import { supabase } from "../supabase/supabase";

interface IRoundBlackCard {
    game?: string;
    player?: number;
    blackCardIdx?: number;
    isOpen?: boolean;
}

export class RoundBlackCard {
    game: string;
    player: number;
    blackCardIdx: number;
    isOpen: boolean;

    constructor(game: string, player: number, blackCardIdx: number, isOpen: boolean) {
        this.game = game;
        this.player = player;
        this.blackCardIdx = blackCardIdx;
        this.isOpen = isOpen;
    }

    static fromJson(json: IRoundBlackCard) {
        const gameId = json.game ? json.game as string : "";
        const playerId = json.player ? json.player as number : 0;
        const theBlackCardIdx = json.blackCardIdx !== undefined ? json.blackCardIdx as number : -1;
        const open = json.isOpen ? json.isOpen as boolean : false;
        return new RoundBlackCard(
            gameId,
            playerId,
            theBlackCardIdx,
            open,
        );
    }

    static async addNewRoundBlackCard(gameId: string, playerId: number) {
        const { data, error } = await supabase
            .from("RoundBlackCards")
            .insert({
                game: gameId,
                player: playerId,
                blackCardIdx: -1,
                isOpen: false,
            });
    }

    static async updateRoundBlackCardIdx(gameId: string, roundBlackCardIdx: number) {
        const { error } = await supabase
            .from("RoundBlackCards")
            .update({
                blackCardIdx: roundBlackCardIdx,
                isOpen: false,
            })
            .eq("game", gameId);
    }

    static async updatePlayerRoundBlackCardIdx(playerId: number, roundBlackCardIdx: number) {
        const { error } = await supabase
            .from("RoundBlackCards")
            .update({
                blackCardIdx: roundBlackCardIdx,
                isOpen: false,
            })
            .eq("player", playerId);
    }

    static async updateRoundBlackCardIsOpen(playerId: number) {
        const { error } = await supabase
            .from("RoundBlackCards")
            .update({
                isOpen: true,
            })
            .eq("player", playerId);
    }

    static async getRoundBlackCards(gameId: string) {
        const roundBlackCards = [];
        const { data, error } = await supabase
            .from("RoundBlackCards")
            .select(`
                player,
                blackCardIdx,
                isOpen
                `)
            .eq("game", gameId);

        for (let idx = 0; idx < data!.length; idx++) {
            const roundBlackCard = this.fromJson(data![idx]);
            if (roundBlackCard.blackCardIdx !== -1) {
                roundBlackCards.push(roundBlackCard);
            }
        }

        return roundBlackCards;
    }
}